import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Vincular Categorias", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_tela_padrao_crud = _resolveComponent("tela-padrao-crud")!
  const _component_plano_conta_modal = _resolveComponent("plano-conta-modal")!
  const _component_vinculacao_conta_contabil_referenciada_modal = _resolveComponent("vinculacao-conta-contabil-referenciada-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tela_padrao_crud, {
      ref: "refCrud",
      estrutura: _ctx.crudBase.estrutura,
      servicoAPI: _ctx.servicoPlanoContas,
      onExibirModal: _ctx.exibirModal,
      onSincronizaTelaCrud: _ctx.sincronizaTelaCrud
    }, {
      AcoesRecursosInicio: _withCtx(() => [
        (_ctx.crudBase.comunicacao.permissaoAlterar)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              title: "Vincular categorias as Contas Contabéis referenciadas",
              type: "button",
              class: "ant-btn ss-btn-tela",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abrirVinculoCategoriaContaReferenciada()))
            }, [
              _createVNode(_component_icone, { nome: "alterar" }),
              _hoisted_1
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["estrutura", "servicoAPI", "onExibirModal", "onSincronizaTelaCrud"]),
    _createVNode(_component_plano_conta_modal, {
      visivel: _ctx.crudBase.exibirModal,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.crudBase.exibirModal) = $event)),
      operacao: _ctx.crudBase.operacao,
      "onUpdate:operacao": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.crudBase.operacao) = $event)),
      onSincronizarRegistro: _ctx.sincronizarRegistro
    }, null, 8, ["visivel", "operacao", "onSincronizarRegistro"]),
    _createVNode(_component_vinculacao_conta_contabil_referenciada_modal, {
      visivel: _ctx.state.apresentarModalVinculoCategoriaContaReferenciada,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.apresentarModalVinculoCategoriaContaReferenciada) = $event))
    }, null, 8, ["visivel"])
  ], 64))
}